import { render, staticRenderFns } from "./productStockDetails.vue?vue&type=template&id=5eb13222&"
import script from "./productStockDetails.vue?vue&type=script&lang=js&"
export * from "./productStockDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports